import { makeStyles } from '@material-ui/styles'

const printTicketStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(3.2),
    width: 215,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex*start',
    alignItems: 'center',
  },
  textMarginTop: {
    marginTop: theme.spacing(1.6),
  },
}))

export default printTicketStyles
